<template>
  <v-card flat color="transparent" height="100%">
    <v-window v-model="window">
      <v-window-item eager v-for="(project, n) in projects" :key="`project-${n}`">
        <v-container fluid grid-list-xs>
          <v-layout row wrap justify-center>
            <v-flex xs12 md10 lg5>
              <v-img :src="project.logo"></v-img>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs12 md8 lg10 xl7>
              <v-card flat class="transparent">
                <v-img contain :src="project.image"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap justify-space-around>
            <v-flex xs2 md3 v-for="(image, n) in project.technologies" :key="`${n}-techstack`">
              <v-card flat class="transparent">
                <v-img height="100%" contain :src="image"></v-img>
                <div class="subheader-1 grey--text">Subheading</div> 
              </v-card>
            </v-flex>
          </v-layout> -->
          <!-- <v-layout row wrap>
            <v-flex xs12>
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="pink">mdi-star</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Design</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-flex>
          </v-layout>-->
        </v-container>
      </v-window-item>
    </v-window>
  </v-card>
</template>

<script>
export default {
  props: ["projects"],
  data() {
    return {
      window: 0,
      length: 3
    };
  },
  computed: {
    nextTitle() {
      let i = 0;
      if (this.window + 1 === this.projects.length) {
        i = 0;
      } else {
        i = this.window + 1;
      }
      return this.projects[i].title;
    },
    backTitle() {
      let i = 0;
      if (this.window === 0) {
        i = this.projects.length - 1;
      } else {
        i = this.window - 1;
      }
      return this.projects[i].title;
    }
  },
  methods: {
    next() {
      if (this.window + 1 === this.projects.length) {
        this.window = 0;
      } else {
        this.window++;
      }
    },
    back() {
      if (this.window === 0) {
        this.window = this.projects.length - 1;
      } else {
        this.window--;
      }
    }
  }
};
</script>

<style>
</style>
